import { set, toggle } from '@/utils/vuex';

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  setRootNavigation: (state, payload) => {
    state.menuRoot = payload;
  },
  setManualHistory: (state, payload) => {
    state.manualHistory = payload;
  },
  addManualHistory: (state, payload) => {
    const { name, params, query, hash } = payload;
    state.manualHistory = [...state.manualHistory, { name, params, query, hash }];
  },
};
